import { render } from "./FraudNoticeComplaint.vue?vue&type=template&id=5bf7ab80&scoped=true"
import script from "./FraudNoticeComplaint.vue?vue&type=script&lang=js"
export * from "./FraudNoticeComplaint.vue?vue&type=script&lang=js"

import "./FraudNoticeComplaint.vue?vue&type=style&index=0&id=5bf7ab80&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf7ab80"]])

export default __exports__